import axiosInstance from './axiosInstance';

export const authService = {
  login: (email, password) =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/login/`, { email, password }),

  register: (email, password1, password2, name) =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/registration/`, {
      email,
      password1,
      password2,
      name
    }),

  passwordReset: (email) =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/password/reset/`, { email }),

  passwordResetConfirm: (uid, token, new_password1, new_password2) =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/password/reset/confirm/`, {
      uid,
      token,
      new_password1,
      new_password2
    }),

  changePassword: (old_password, new_password1, new_password2) =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/password/change/`, {
      old_password,
      new_password1,
      new_password2
    }),

  refreshToken: (refresh) =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/token/refresh/`, { refresh }),

  logout: () =>
    axiosInstance.post(`${process.env.REACT_APP_AUTH_API_URL}/logout/`),

  // Bootstrap endpoint - DOES NOT require X-Customer-ID
  getCollaboratorMe: () =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/collaborators/me/`),
};

// Customer-scoped services - Automatically include X-Customer-ID via interceptor
export const customerService = {
  // Businesses
  getBusinesses: () =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/businesses/`),

  getBusiness: (uuid) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/businesses/${uuid}/`),

  getCustomerBusinesses: () =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/businesses/`),

  getCustomerRoles: () =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/roles/`),

  createBusiness: (data) =>
    axiosInstance.post(`${process.env.REACT_APP_CUSTOMER_API_URL}/businesses/create/`, data),

  updateBusiness: (uuid, data) =>
    axiosInstance.put(`${process.env.REACT_APP_CUSTOMER_API_URL}/businesses/${uuid}/`, data),

  patchBusiness: (uuid, data) =>
    axiosInstance.patch(`${process.env.REACT_APP_CUSTOMER_API_URL}/businesses/${uuid}/`, data),

  deleteBusiness: (uuid) =>
    axiosInstance.delete(`${process.env.REACT_APP_CUSTOMER_API_URL}/businesses/${uuid}/`),

  // Collaborators
  getCollaborators: () =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/collaborators/`),

  getCollaborator: (id) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/collaborators/${id}/`),

  inviteCollaborator: (data) =>
    axiosInstance.post(`${process.env.REACT_APP_CUSTOMER_API_URL}/collaborators/invite/`, data),

  // Conversations
  getConversations: (params) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/conversations/conversations/`, { params }),

  getConversation: (uuid) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/conversations/conversations/${uuid}/`),

  acceptConversation: (uuid) =>
    axiosInstance.post(`${process.env.REACT_APP_CUSTOMER_API_URL}/conversations/conversations/${uuid}/accept/`),

  getMessages: (uuid) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/conversations/conversations/${uuid}/messages/`),

  replyMessage: (uuid, data) =>
    axiosInstance.post(`${process.env.REACT_APP_CUSTOMER_API_URL}/conversations/conversations/${uuid}/reply/`, data),

  // Customers
  getCustomers: (params) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/`, { params }),

  getCustomer: (uuid) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/${uuid}/`),

  createCustomer: (data) =>
    axiosInstance.post(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/`, data),

  updateCustomer: (uuid, data) =>
    axiosInstance.put(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/${uuid}/`, data),

  patchCustomer: (uuid, data) =>
    axiosInstance.patch(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/${uuid}/`, data),

  deleteCustomer: (uuid) =>
    axiosInstance.delete(`${process.env.REACT_APP_CUSTOMER_API_URL}/customers/${uuid}/`),

  // Providers
  getProviders: () =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/providers/`),

  getProvider: (uuid) =>
    axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_API_URL}/providers/${uuid}/`),
};

export const apiClient = axiosInstance;

export default axiosInstance;
